export interface UserSettings {
    onthoudEmail? : boolean;
    Username? : string;
}

export class UserSettingsHelpers {
    static getUserSettings(): UserSettings {
        return JSON.parse(window.localStorage.getItem('UserSettings') || '{}');
    }
    static browserStoreUserSettings(settings: UserSettings) {
        window.localStorage.setItem('UserSettings', JSON.stringify(settings));
    }
}
